<div class="chordToolContainer">
  <h1 class="mat-text-2">Chord Tool</h1>

  <app-chord-controls-bar></app-chord-controls-bar>
  <app-chord-detail-bar></app-chord-detail-bar>
  <app-fretboard></app-fretboard>
  <app-show-chords-help *ngIf="data.showHelp"></app-show-chords-help>
</div>
